import { cn } from "@onclicks/sharedcomponents/ui";
import toast, { Toast as ToastType } from "react-hot-toast";
import Icon from "../ui/icon";

type ToastContentProps = {
  t: ToastType;
  icon: string;
  iconClass: string;
  bgIcon: string;
  title: string;
  message?: string;
  accentClass: string;
  /** Rend le toast cliquable (le bouton de fermeture reste, lui, neutre). */
  onClick?: () => void;
};

const CustomToast = (props: ToastContentProps) => {
  const { t, icon, iconClass, bgIcon, title, message, accentClass, onClick } =
    props;

  return (
    <div
      className={cn(
        "pointer-events-auto w-80 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg dark:border-slate-700/50 dark:bg-slate-800",
        t.visible ? "animate-slide-in" : "animate-slide-out",
        onClick && "cursor-pointer",
      )}
      onClick={onClick}
    >
      <div className={cn("h-1", accentClass)} />

      <div className="flex items-start gap-3 p-4">
        <div
          className={cn(
            "flex shrink-0 items-center justify-center w-9 h-9 rounded-xl",
            bgIcon,
          )}
        >
          <Icon name={icon} className="text-lg" />
        </div>

        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold text-slate-800 dark:text-white">
            {title}
          </p>
          {message && (
            <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400 line-clamp-2">
              {message}
            </p>
          )}
        </div>

        <button
          onClick={(evenement) => {
            evenement.stopPropagation();
            toast.dismiss(t.id);
          }}
          className="shrink-0 flex items-center justify-center w-7 h-7 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 dark:hover:bg-slate-700 dark:hover:text-slate-300 transition-all"
        >
          <Icon name="close" className="text-base" />
        </button>
      </div>
    </div>
  );
};

export default CustomToast;
